import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

// import { setupSnowplowIntegration } from '@dbt-labs/integrations/snowplow';
// import { getConstants } from '@dbt-labs/stable-api/constants';
import { ExposureTile } from '@dbt-labs/metadata-embeds';

import './index.css';

const DISCOVERY_API_BASE_URL = import.meta.env.VITE_DISCOVERY_API_BASE_URL;

const initializeApp = async () => {
  const container = document.getElementById('root');
  if (!container) throw new Error('No container found');
  const root = createRoot(container);

  // TODO: using the 'integrations' and 'stable-api' packages requires hosting this vertical slice on dbt Cloud
  // uncomment the following as part of META-4299

  /*
  const constants = await getConstants();
  const { environment_configuration: envConfig } = constants;
  const { disable_anonymous_tracking, env, dbt_instance } = envConfig;

  const isProd = env === 'prod';
  if (isProd && !disable_anonymous_tracking) {
    const userId = undefined;
    const appId = 'exposure-tile';
    setupSnowplowIntegration(userId, appId);
    console.debug('Set up snowplow integration.');
  }
  */

  root.render(
    <StrictMode>
      <ExposureTile
        uriOverride={
          import.meta.env.MODE === 'development' ? DISCOVERY_API_BASE_URL : undefined
        }
        // dbtInstance={dbt_instance}
      />
    </StrictMode>,
  );
};

(async () => {
  await initializeApp();
})();
